import { outlinedInputClasses, inputAdornmentClasses } from '@ori-ui/mui-bundle/material';
import { textInputData } from '../constants';

// text field

const styleOverrides = {
  root: {
    borderRadius: 5,
    [`&.${outlinedInputClasses.multiline} .${inputAdornmentClasses.root}`]: {
      alignSelf: 'flex-start',
      marginTop: 16,
      marginRight: 4,
      marginLeft: 4
    }
  },
  inputSizeSmall: {
    padding: '8.5px 14px'
  },
  adornedStart: {
    [`& .${outlinedInputClasses.input}`]: {
      paddingLeft: 0
    }
  },
  adornedEnd: {
    [`& .${outlinedInputClasses.input}`]: {
      paddingRight: 0
    }
  },
  notchedOutline: {
    background: 'unset',
    borderColor: textInputData.border.color,
    '& legend': {
      position: 'unset'
    }
  },
  multiline: {
    padding: 15
  }
};
const defaultProps = {
  color: 'inputElements'
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiOutlinedInput.js.map